var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOurServiceLeftBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 278,
    height: 235,
    viewBox: "0 0 278 235",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.4882 124.547C-7.80366 118.589 -35.3145 139.082 -35.959 170.322C-36.6035 201.561 -10.1376 231.716 23.1542 237.674C56.446 243.633 83.9568 223.139 84.6013 191.9C85.2458 160.661 58.78 130.506 25.4882 124.547Z",
    stroke: "#3F97FF",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2761 101.355C1.43239 96.0804 -35.4232 127.556 -35.0432 171.658C-34.6632 215.76 2.80847 255.788 48.6522 261.063C94.4959 266.337 131.352 234.861 130.972 190.759C130.592 146.657 93.1198 106.63 47.2761 101.355Z",
    stroke: "#3F97FF",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3178 74.815C9.11668 71.9837 -36.383 115.943 -34.3085 173.001C-32.234 230.059 16.6291 278.608 74.8303 281.44C133.031 284.271 178.531 240.312 176.457 183.254C174.382 126.196 125.519 77.6462 67.3178 74.815Z",
    stroke: "#3F97FF",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3273 45.3421C14.9185 46.7324 -38.5785 104.543 -34.1616 174.466C-29.7446 244.389 30.9136 299.946 101.322 298.556C171.731 297.165 225.228 239.355 220.811 169.432C216.394 99.5086 155.736 43.9519 85.3273 45.3421Z",
    stroke: "#3F97FF",
    strokeWidth: 3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M101.016 13.3838C18.5038 20.7755 -42.3935 93.6571 -35.0018 176.169C-27.6101 258.682 45.2714 319.579 127.784 312.187C210.296 304.796 271.193 231.914 263.802 149.402C256.41 66.8894 183.528 5.99216 101.016 13.3838Z",
    stroke: "#3F97FF",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOurServiceLeftBg);
export default __webpack_public_path__ + "static/media/ourServiceLeftBg.45564b1bf8b17707fdfdc9cb8741ff30.svg";
export { ForwardRef as ReactComponent };